<template>
  <modal :show.sync="modalEdit">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.category_product.edit.title") }}
    </h4>
    <ValidationObserver ref="formEdit" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(editRow)">


        <div v-for="(lang) in category.traducciones">
          <h6>{{ lang.idioma.idioma }}</h6>
          <div class="row">
            <div class="col-12">
              <fg-input
                type="text"
                name="minLength"
                :label="$t('app.modules.category_product.headers.name')"
                v-model="lang.nombreCategoria"
              >
              </fg-input>
            </div>
          </div>
          <div class="separate"></div>
        </div>


        <div class="col-sm-6 form-group has-label">
          <div class="row">
            <label style="margin-left: 15px">{{
              $t("app.modules.messages.headers.state")
            }}</label>
          </div>
          <template>
            <n-switch v-model="category.activo">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </template>
        </div>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelEdit()">{{
            $t("app.buttons.cancel")
          }}</n-button>
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
import { mapState } from "vuex";
import CategoriaProducto from "@/models/familiaProducto/CategoriaProducto";
import {getResponse} from "@/util/utilities";

export default {
  components: {},
  data() {
    return {
      required_text: this.$t("app.general.required"),
      sizes: "col-md-6 col-sm-12",
      category: new CategoriaProducto(),
      modalEdit: false
    };
  },
   computed: {
     ...mapState(["user", "availableLangs"])
  },
  created() {
    this.category.claveIdioma = this.$store.state.lang;
  },
  mounted() {
    EventBus.$on("categoriaproducto-edit",  item => {
      this.category = item;
      this.category.usuario = this.user.name;
      this.category.usuarios_IdUsuario = this.user.idUsuario;

      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.modalEdit = true;
    });
  },
  methods: {
    cancelEdit() {
      this.modalEdit = false;
      this.$refs.formEdit.reset();
    },
    async editRow() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      }).then(null);

      try
      {
        this.category.traducciones.forEach(t => {
          if(!t.nombreCategoria) throw new Error(this.$t('app.modules.category_product.errors.no_name') + ": " + t.idioma.idioma);
        });

        let request = await this.$http.put(route("CategoriaProducto/UpdateCategoriaProducto"), this.category);
        let response = getResponse(request, null);

        if(response){
          this.notifyMessage("success", this.$t("app.promps.save_success"));
          EventBus.$emit("reload-items");
          this.cancelEdit();
        }
        else this.notifyMessage("danger", this.$t("app.promps.error"));
      }
      catch (e){
        this.notifyMessage('danger', e.message);
      }
      finally
      {
        this.$swal.close();
      }
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0 2px 5px 0 #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
